import {Component} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {NgxsModule} from '@ngxs/store';
import {ResultsState} from './states/results-state/results.state';
import {HttpClientModule} from '@angular/common/http';

@Component({
  selector: 'app-root',
  imports: [
    HttpClientModule,
    RouterOutlet
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'axxer-insurance-comparator';
}
